export default "__VITE_ASSET__86a9cf37__"